<div class="progress-circle" (click)="showDialog()">
  <svg [attr.width]="sizeWH" [attr.height]="sizeWH" role="img" aria-hidden="true">
    <circle [attr.cx]="coordinates" [attr.cy]="coordinates" [attr.r]="radius"></circle>
    <circle
      [attr.cx]="coordinates"
      [attr.cy]="coordinates"
      [attr.r]="radius"
      [attr.stroke-dashoffset]="size - (size * progress) / 100"></circle>
  </svg>
  <span class="step pb-0.5" [innerHTML]="step + '/' + maxStep"></span>
</div>

<p-dialog
  [(visible)]="displayModal"
  [style]="{ width: '345px', height: '660px', margin: '1rem' }"
  [closable]="false"
  [baseZIndex]="10000">
  <ng-template pTemplate="header">
    <p class="title-modal mt-4" [innerHTML]="resource.stepper.mySteps"></p>
    <img
      class="button-close-modal cursor-pointer"
      [src]="resource.header.closemodal"
      (click)="displayModal = false"
      alt="close" />
  </ng-template>
  <p class="subtitle-modal" [innerHTML]="resource.stepper.returnToStep"></p>
  <div class="mt-4">
    <div *ngFor="let stepShow of stepper.steps">
      <div *ngIf="stepShow.isVisible">
        <div *ngFor="let step of stepShow.titles; let i = index">
          <div class="flex my-1.5">
            <div class="flex items-center justify-center w-8">
              <span
                class="step-summary flex items-center justify-center w-8"
                [ngClass]="{
                  enable: step.isActive,
                  disabled: !step.isActive
                }"
                [innerHTML]="i + 1"></span>
            </div>
            <div
              class="grow mx-3 title-summary"
              [ngClass]="{
                valid: step.isActive,
                invalid: !step.isActive
              }"
              [innerHTML]="step.libelle"></div>
            <div class="flex-none w-8 mt-[5px]"></div>
          </div>
          <div *ngFor="let subStep of step.subtitles">
            <div class="flex my-1.5" *ngIf="!subStep.isValid && !subStep.isActive">
              <div class="flex-none w-8"></div>
              <div class="grow title-step invalid mx-3" [innerHTML]="subStep.libelle"></div>
            </div>
            <div
              class="flex my-0.5"
              *ngIf="subStep.isActive || (subStep.isValid && !subStep.isActive)">
              <div class="flex items-center justify-center w-8">
                <div
                  *ngIf="subStep.isActive"
                  class="subStepEnableBackground background-norepeat rounded-full flex items-center justify-center">
                  <span class="subStepEnableFront background-norepeat rounded-full"></span>
                </div>
                <div *ngIf="subStep.isValid && !subStep.isActive" class="stepTracking_bg"></div>
              </div>
              <div
                class="grow title-step mx-3"
                [ngClass]="{
                  valid: subStep.isValid && !subStep.isActive,
                  progress: subStep.isActive
                }">
                <a
                  [routerLink]="subStep.url"
                  routerLinkActive="router-link-active"
                  [innerHTML]="subStep.libelle"></a>
              </div>
              <div
                *ngIf="subStep.isValid"
                class="flex-none w-8 checkSummary background-norepeat mt-1"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
